import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import { Article } from '../shared/article.model';
// import { ArticleService } from "../shared/article.service";
import { Eventos, EventService } from '../shared';

@Component({
  selector: 'bp-event-list',
  templateUrl: 'event-list.component.html'
})

export class EventListComponent implements OnDestroy, OnInit {

  events: Eventos[] = [];
  filteredEvents = this.events;

  constructor(
    private eventsService: EventService
  ) { }

  ngOnInit() {
    this.getEvents();

  }

  ngOnDestroy(): void {

  }

  getEvents() {
    this.events = [];

    this.eventsService.getEvents(0)
      .subscribe(events => {
        this.events = this.filteredEvents = events;
      });
  }

  trackByCharacters(index: number, article: Eventos) {
    return article.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/events/event-list/event-list.component.ts